/**
 * @param {unknown} html
 * @returns {string}
 */
export function unescapeHtml(html) {
  const doc = new DOMParser().parseFromString(html?.toString() ?? '', 'text/html');
  return doc.documentElement.textContent ?? '';
}
